import { render, staticRenderFns } from "./addSignConfirm.vue?vue&type=template&id=1ce9b4c7&scoped=true"
import script from "./addSignConfirm.vue?vue&type=script&lang=js"
export * from "./addSignConfirm.vue?vue&type=script&lang=js"
import style0 from "./addSignConfirm.vue?vue&type=style&index=0&id=1ce9b4c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce9b4c7",
  null
  
)

export default component.exports